
const digest = '7f5ed85548655ccc32eb2089098ccdb56f235e26eedd0075c78fc837a2c4b2a5';
const classes = {"loader":"_loader_1r676_1","l7":"_l7_1r676_1","background":"_background_1r676_21"};
const css = `._loader_1r676_1 {
  width: 30px;
  aspect-ratio: 5;
  --_g: no-repeat radial-gradient(circle closest-side, #bbc5cc 90%,#0000);
  background: var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;
  background-size: 33.3333333333% 100%;
  animation: _l7_1r676_1 1s infinite linear;
}

@keyframes _l7_1r676_1 {
  33% {
    background-size: 33.3333333333% 0%, 33.3333333333% 100%, 33.3333333333% 100%;
  }
  50% {
    background-size: 33.3333333333% 100%, 33.3333333333% 0%, 33.3333333333% 100%;
  }
  66% {
    background-size: 33.3333333333% 100%, 33.3333333333% 100%, 33.3333333333% 0%;
  }
}
._background_1r676_21 {
  background-color: #fbfbfd;
  padding: 0 24px;
  margin-top: -20px;
  height: 54px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  